module.exports = __webpack_public_path__ + "img/arrow-left.1d11f7b7.svg";